import { RequiredDocumentsContainer } from '@/modules/DocumentsSettings';

const RequiredDocuments = (): JSX.Element => <RequiredDocumentsContainer />;

export default RequiredDocuments;
